export default __webpack_public_path__ + "static/media/isotipo-500x500.02bbcec1.webp";